import React from 'react';
import EventsCarousel from './components/EventsCarousel';

function App() {
  return (
    <div>
      <EventsCarousel />
    </div>
  );
}

export default App;